import React from "react";
import "./Loading.css";
import ReactLoading from "react-loading";
import { useSelector } from "react-redux";
import { DivRef } from "../../../../utils/typesAndMaps";
import { RootStore } from "../../../../store";

interface LoadingProps {
  errorMessage: string,
  loadingRef: DivRef,
  errorRef: DivRef,
}

export default function Loading({ errorMessage, loadingRef, errorRef }: LoadingProps) {
  const generalStates = useSelector((store: RootStore) => store.generalStates);

  const closeError = () => {
    errorRef.current!.style.display = "none";
  }

  return (
    <div className="dbr-loading">
      <div className="dbr-main-loading" ref={loadingRef}>
        <div className="dbr-loading-header">{generalStates.loadingContent}<ReactLoading className="dbr-text-loading" type="bubbles" width="20px" height="20px"></ReactLoading></div>
        <div className="dbr-error-header">{errorMessage}</div>
        <div className="dbr-loading-animation">
          <svg width="150" height="150" viewBox="0 0 100 100"><path d="M 1.5,2 L 98,2 L 98,98 L 2,98 L 2,2" stroke="#eee" strokeWidth="1" fillOpacity="0"></path><path className="dbr-path-loading-svg" d="M 0,2 L 98,2 L 98,98 L 2,98 L 2,4" stroke="rgba(254, 142, 20,0.6)" strokeWidth="6" fillOpacity="0"></path></svg>
        </div>
      </div>
      <div className="dbr-error-header" ref={errorRef}>
        <span>{errorMessage}</span>
        <svg width="24" height="24" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" onClick={closeError}><path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"></path></svg>
      </div>
    </div>
  )
}